import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 30 30",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_348_1465",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 30,
			height: 30,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 30,
				height: 30,
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_348_1465)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M25.4639 15.9374H10.7212V14.0625H25.4639L23.1899 11.7884L24.5072 10.4327L29.0744 15L24.5072 19.5673L23.1899 18.2115L25.4639 15.9374ZM19.0024 11.0817V6.63463C19.0024 6.52244 18.9663 6.43028 18.8942 6.35816C18.8221 6.28603 18.7299 6.24997 18.6177 6.24997H6.63462C6.52244 6.24997 6.43028 6.28603 6.35816 6.35816C6.28603 6.43028 6.24997 6.52244 6.24997 6.63463V23.3653C6.24997 23.4775 6.28603 23.5697 6.35816 23.6418C6.43028 23.7139 6.52244 23.75 6.63462 23.75H18.6177C18.7299 23.75 18.8221 23.7139 18.8942 23.6418C18.9663 23.5697 19.0024 23.4775 19.0024 23.3653V18.9183H20.8773V23.3653C20.8773 23.9887 20.6566 24.5212 20.2151 24.9627C19.7736 25.4042 19.2411 25.6249 18.6177 25.6249H6.63462C6.01123 25.6249 5.47878 25.4042 5.03728 24.9627C4.59576 24.5212 4.375 23.9887 4.375 23.3653V6.63463C4.375 6.01123 4.59576 5.47878 5.03728 5.03728C5.47878 4.59576 6.01123 4.375 6.63462 4.375H18.6177C19.2411 4.375 19.7736 4.59576 20.2151 5.03728C20.6566 5.47878 20.8773 6.01123 20.8773 6.63463V11.0817H19.0024Z",
				fill: "currentColor"
			})
		})
	]
});
export default SvgLogout;
